import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import Drawer from 'react-modern-drawer';
import { Container } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import { readMore } from '../../utils/utilities';
import moment from 'moment';
import BaseLayout from '../../components/BaseLayout';
import Tabs from '../../components/Tabs';
import NotFound from '../../components/NotFound';
import ApiUtils from '../../utils/api_utils';
import * as Assets from '../../utils/svg_assets';
import * as PageRoutes from './../../utils/route_pages';
import { ReceiptAttachmentDialog } from '../../components/DialogCollection';
import { statusSnapReceipt } from '../../utils/constant';
import { priceDecimal } from '../../utils/utilities';
import { InformationDialog } from '../../components/DialogCollection';
import PreviewImage from '../../components/PreviewImage';
import './style.scss';
import CameraRecorderReceipt from '../../components/CameraRecorderReceipt';
import HeaderReceipt from '../../components/HeaderReceipt';

const SnapReceiptPage = (props) => {
  const initPayload = {
    title: '',
    description: '',
    img: '',
    img2: '',
    img3: '',
    video: '',
    file: '',
  };
  const { getData, listReceipt, getRetrieveSetting, setting } = props;
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(1);
  const [type, setType] = useState(null);
  const [order, setOrder] = useState('-created');
  const [isAccessMenu, setIsAccessMenu] = useState(true);
  const [isPreview, setIsPreview] = useState(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [attachmentType, setAttachmentType] = useState('photo');
  const [typeAction, setTypeAction] = useState('add');
  const [showDrawerAttachment, setShowDrawerAttachment] = useState(false);
  const [payload, setPayload] = useState(initPayload);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const openModal = queryParams.get('openModal');
  let [images] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const tabs = [
    {
      id: 1,
      name: 'On Progress',
      status: 'on_progress',
    },
    {
      id: 2,
      name: 'Approved',
      status: 'approved',
    },
    {
      id: 3,
      name: 'Rejected',
      status: 'rejected',
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const tabFromUrl = parseInt(urlParams.get('tab'), 10);

    if (tabFromUrl) {
      setIsActive(tabFromUrl);
      if (tabFromUrl === 1) {
        setType('on_progress');
        setOrder('-created');
      } else if (tabFromUrl === 2) {
        setType('approved');
        setOrder('-created');
      } else {
        setType('rejected');
        setOrder('-created');
      }
    } else {
      setIsActive(1);
      setType('on_progress');
      setOrder('-created');
    }

    if (type) {
      getData(type, order).finally(() => setIsLoading(false));
    }
  }, [type, order]);

  useEffect(() => {
    if (openModal) {
      setShowAttachment(true);
    }
  }, [openModal]);

  useEffect(() => {
    if (setting && !setting.is_active) {
      setIsAccessMenu(false);
    }
  }, []);

  const onChangeTabs = (tabActive) => {
    setIsActive(tabActive);

    const url = new URL(window.location);
    url.searchParams.set('tab', tabActive);
    window.history.replaceState({}, document.title, url);

    if (tabActive === 1) {
      setType('on_progress');
      setOrder('-created');
    } else if (tabActive === 2) {
      setType('approved');
      setOrder('-created');
    } else {
      setType('rejected');
      setOrder('-created');
    }
  };

  const LoadingSpinner = () => (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
    </div>
  );

  const SectionTab = () => {
    return (
      <div className="d-flex wrapper-tab align-items-center p-0 overflow-none justify-content-around">
        {tabs.map((tab, index) => (
          <Tabs
            id={tab.id}
            key={index}
            name={tab.name}
            isActive={isActive}
            onClick={() => onChangeTabs(tab.id)}
          />
        ))}
      </div>
    );
  };

  const filterStatus = (status, key = 'name') => {
    const result = statusSnapReceipt
      .filter((e) => {
        return e.key === status;
      })
      .map((e) => e[key]);

    return result.length > 0 ? result[0] : null;
  };

  const removeQueryParam = () => {
    const url = new URL(window.location);
    url.searchParams.delete('openModal');
    window.history.replaceState({}, document.title, url);
  };

  const ListReceipt = (data) => {
    const {
      id,
      product,
      category,
      image,
      status,
      transaction_date,
      amount,
      total_point,
    } = data.data;
    return (
      <>
        <div
          onClick={() => {
            removeQueryParam();
            navigate(`${PageRoutes.snapReceipt}/detail/${id}`);
          }}
          className="d-flex align-items-center mb-4"
        >
          <div
            className="mr-1"
            style={{
              backgroundSize: 'cover',
              height: 106,
              width: 106,
              backgroundPosition: 'center',
              border: '1px solid #cecece',
              borderRadius: 10,
              backgroundImage: `url(${ApiUtils.validateImgUrl({
                url: image,
              })})`,
            }}
          ></div>
          <div style={{ flex: 1 }}>
            {' '}
            <div className="fs-14 text-black-400">
              {ReactHtmlParser(readMore(product, 25))}
            </div>
            <div className="d-flex justify-content-between">
              <div className="mr-1">
                <div className="text-black-400 fs-12">{category}</div>
                <div className="text-black-400 fs-14">
                  IDR {priceDecimal(amount)}
                </div>
                {status === 'approved' && (
                  <div className="text-black-400 fs-14">+{total_point} Pts</div>
                )}
                {status === 'rejected' && (
                  <div className="text-black-400 fs-14">- Pts</div>
                )}
                {status === 'on_progress' && (
                  <div className="text-black-400 fs-14">- Pts</div>
                )}
              </div>
              <div
                className="d-flex flex-column align-items-end"
                style={{ marginLeft: 'auto', textAlign: 'right' }}
              >
                <div className="text-black-400 fs-14">
                  {moment(transaction_date).format('DD MMM YYYY')}
                </div>
                <div
                  className="text-black-400 fs-12 text-uppercase"
                  style={{ color: filterStatus(status, 'color') }}
                >
                  {filterStatus(status)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </>
    );
  };

  const upsertImage = (newImage) => {
    // Check if the image with the same id already exists
    const index = images.findIndex((image) => image.slug === newImage.slug);

    if (index !== -1) {
      // Replace the existing image if id is found
      images[index] = newImage;
    } else {
      // Insert the new image if id is not found
      images.push(newImage);
    }
  };

  return (
    <div id="receipt-page">
      {!isAccessMenu ? (
        <InformationDialog
          title="Warning"
          style={{ width: '300px' }}
          message={'Dont have permission to access this menu'}
          closeLabel="Done"
          show={isAccessMenu}
          onHide={() => {
            navigate(PageRoutes.home);
          }}
        />
      ) : (
        <>
          {isPreview ? (
            <PreviewImage
              payload={payload}
              images={images}
              onTakePhoto={(type) => {
                setTypeAction(type);
                setIsPreview(false);
                setShowAttachment(true);
              }}
              onCancel={() => {
                images = [];
                setPayload(initPayload);
                removeQueryParam();
                setIsPreview(false);
              }}
            />
          ) : (
            <BaseLayout
              bottomNavIndex={1}
              isCustom={true}
              show_menu={false}
              header={
                <HeaderReceipt
                  toPath={PageRoutes.home}
                  page="Receipt"
                  bgImg={`${Assets.bannerSnapReceipt}`}
                  isFlex={true}
                  content={
                    <div className="overlay d-flex align-items-center justify-content-between text-white font-bold mt-9-vh">
                      <div className="fs-medium fs-medium-margin-left">
                        Receipt
                      </div>
                      <div
                        className="fs-medium-margin-right"
                        onClick={() => setShowAttachment(true)}
                      >
                        Add New{' '}
                        <img
                          src={`${Assets.iconPlusOrange}`}
                          alt="Plus Orange"
                        />
                      </div>
                    </div>
                  }
                />
              }
            >
              <>
                <SectionTab />
                {isLoading ? (
                  <LoadingSpinner />
                ) : listReceipt.length === 0 ? (
                  <NotFound
                    img={Assets.snapReceiptNotFound}
                    title="You have no transaction"
                    subTitle="Please add the receipt transaction. Tap on “Add New” button at the top."
                  />
                ) : (
                  <div className="p-bottom">
                    {listReceipt.map((data, index) => (
                      <ListReceipt key={index} data={data} />
                    ))}
                  </div>
                )}
                <ReceiptAttachmentDialog
                  show={showAttachment}
                  onClose={() => setShowAttachment(false)}
                  attachmentType={attachmentType}
                  showAttachmentCamera={() => setShowDrawerAttachment(true)}
                  setAttachmentType={setAttachmentType}
                  payload={payload}
                  setPayload={(payload) => {
                    if (payload.img) {
                      upsertImage({
                        slug: 'img',
                        image: payload.img,
                      });
                    }
                    if (payload.img2) {
                      upsertImage({
                        slug: 'img2',
                        image: payload.img2,
                      });
                    }
                    setPayload(payload);
                    setIsPreview(true);
                  }}
                  typeAction={typeAction}
                />

                <Drawer
                  open={showDrawerAttachment}
                  onClose={() => setShowDrawerAttachment(false)}
                  size={'100%'}
                  direction="bottom"
                  overlayColor={'#080707'}
                  overlayOpacity={0.5}
                  style={{
                    padding: '20px',
                    textAlign: 'center',
                  }}
                >
                  <Container>
                    <CameraRecorderReceipt
                      payload={payload}
                      setPayload={(payload) => {
                        if (payload.img) {
                          upsertImage({
                            slug: 'img',
                            image: payload.img,
                          });
                        }
                        if (payload.img2) {
                          upsertImage({
                            slug: 'img2',
                            image: payload.img2,
                          });
                        }
                        setPayload(payload);
                        setIsPreview(true);
                      }}
                      attachmentType={attachmentType}
                      typeAction={typeAction}
                      onClose={() => setShowDrawerAttachment(false)}
                    />
                  </Container>
                </Drawer>
              </>
            </BaseLayout>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  listReceipt: state.SnapReceiptSM.listReceipt,
  setting: state.SnapReceiptSM.setting,
});

const mapDispatchToProps = (dispatch) => ({
  getData: dispatch.SnapReceiptSM.getData,
  getRetrieveSetting: dispatch.SnapReceiptSM.getRetrieveSetting,
});

export default connect(mapStateToProps, mapDispatchToProps)(SnapReceiptPage);
